import axios from "axios";
import { RewardsAccountsResponse } from "redmond";

import { config } from "../../config";
import { fetchRewardsAccountsPath } from "../paths";

export const fetchRewardsAccounts = (): Promise<RewardsAccountsResponse> =>
  new Promise(async (resolve, reject) => {
    try {
      const res = await axios.put(
        fetchRewardsAccountsPath,
        {},
        {
          baseURL: config.baseURL,
        }
      );

      resolve(res.data);
    } catch (e) {
      reject(e);
    }
  });
